export const OPERATOR_REGISTER_FILE_NAME = "OperatorRegister";

/** wordListが準備できているか判定するために必要なラベルキー一覧。 */
export const REQUIRED_FIELD_LABEL_KEYS = [
  'lbl_operator_group',
  'lbl_chain_name',
  'lbl_shop_name',
  'lbl_operator_id',
  'lbl_operator_regist_name',
  'lbl_auth_type',
  'lbl_personal_info_browsing',
  'lbl_personal_info_download',
  'lbl_auth_email',
  'lbl_auth_tel',
  'lbl_auth_password',
  'lbl_auth_password_comfirm',
] as const;
